import { ICorporatePolicyState } from "../types";

const state: ICorporatePolicyState = {
  policyBuilderConfig: null,
  isFetchingPolicyBuilderConfig: false,
  corporatePolicies: [],
  isFetchingCorporatePolicies: false,
  selectedCorporatePolicy: null,
  isFetchingCorporatePolicy: false,
  corporatePolicyActionLoading: false,
};

export default state;
